import LoginForm from '../components/Auth/LoginForm';

function Login() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <LoginForm />
    </div>
  );
}

export default Login;
